import {z as r} from 'zod';

import {
    filterSuggestionSchema,
    FilterSuggestionType,
    GroupOperationsEnum,
    MainFilterFieldNameEnum,
} from './main-filter-type';

export enum MainFilterSelectedValuesIdsKeyEnum {
    GROUPS = 'group_ids',
    BRANDS = 'brand_ids',
    COUNTRIES = 'countries_ids',
    REGIONS = 'region_ids',
    CITIES = 'cities_ids',
    STREETS = 'streets',
    NAMES = 'names',
    CODES = 'codes',
    IS_PAID = 'is_paid',
    NEED_MODERATE = 'need_moderate',
    GROUPS_LOGICAL_OPERATION = 'group_operation',
}

export enum MainFilterSelectedValuesIdsPriorityPlacementEnum {
    PRIORITY_PLACEMENT = 'is_priority_placement',
    NOT_PRIORITY_PLACEMENT = 'is_not_priority_placement',
}

export enum MainFilterSelectedValuesIdsAdditionalKeyEnum {
    CLOSED = 'is_company_closed',
    ACTIVE = 'is_company_active',
}

export enum SuggestionApiFieldNameEnum {
    GROUPS = 'group',
    GROUPS_LOGICAL_OPERATION = 'group_operation',
    BRANDS = 'brand',
    COUNTRIES = 'country',
    REGIONS = 'region',
    CITIES = 'city',
    STREETS = 'street',
    NAMES = 'name',
    CODES = 'code',
    CLOSED = 'closed',
    ACTIVE = 'active',
    PRIORITY_PLACEMENT = 'priority_placement',
    IS_PAID = 'is_paid',
    NEED_MODERATE = 'need_moderate',
}

export type MainFilterSelectedValuesApiType = Record<
    Exclude<
        MainFilterSelectedValuesIdsKeyEnum,
        | MainFilterSelectedValuesIdsKeyEnum.NEED_MODERATE
        | MainFilterSelectedValuesIdsKeyEnum.IS_PAID
        | MainFilterSelectedValuesIdsKeyEnum.GROUPS_LOGICAL_OPERATION
    >,
    Array<string> | boolean | null
> &
    MainFilterSelectedValuesAdditionalType &
    MainFilterSelectedValuesIdsPriorityPlacementType & {
        [MainFilterSelectedValuesIdsKeyEnum.IS_PAID]?: boolean;
        [MainFilterSelectedValuesIdsKeyEnum.NEED_MODERATE]?: boolean;
        [MainFilterSelectedValuesIdsKeyEnum.GROUPS_LOGICAL_OPERATION]?: GroupOperationsEnum;
    };

export type MainFilterSelectedValuesAdditionalType = {
    [MainFilterSelectedValuesIdsAdditionalKeyEnum.CLOSED]?: Array<boolean | string> | null;
    [MainFilterSelectedValuesIdsAdditionalKeyEnum.ACTIVE]?: Array<string> | boolean | null;
};

export type MainFilterSelectedValuesIdsPriorityPlacementType = {
    [MainFilterSelectedValuesIdsPriorityPlacementEnum.PRIORITY_PLACEMENT]?: Array<string> | boolean | null;
    [MainFilterSelectedValuesIdsPriorityPlacementEnum.NOT_PRIORITY_PLACEMENT]?: Array<string> | boolean | null;
};

export type LoadSuggestionsBodyType = {
    field_name: SuggestionApiFieldNameEnum;
    after: string | null;
    limit: number;
    query: string;
    current_filter: MainFilterSelectedValuesApiType;
};

export type MainFilterCompileResultApiType = {
    key: string;
};

export type MainFilterFilterValuesApiType = {
    current_filter: Record<
        Exclude<
            MainFilterFieldNameEnum,
            | MainFilterFieldNameEnum.IS_PAID
            | MainFilterFieldNameEnum.NEED_MODERATE
            | MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION
        >,
        Array<FilterSuggestionType> | null
    > & {
        is_company_closed?: Array<string>;
        is_company_active?: boolean;
        is_paid?: boolean;
        need_moderate?: boolean;
        group_operation?: GroupOperationsEnum;
    };
    companies_count: number;
};

export type MainFilterGetFilteredCountResultApiType = {
    count: number;
};

export const mainFilterLastStateSchema = r.object({
    key: r.string(),
    filtersAvailable: r.boolean(),
    companiesCount: r.number(),
    currentFilter: r.object({
        groups: r.array(filterSuggestionSchema).optional(),
        brands: r.array(filterSuggestionSchema).optional(),
        countries: r.array(filterSuggestionSchema).optional(),
        regions: r.array(filterSuggestionSchema).optional(),
        cities: r.array(filterSuggestionSchema).optional(),
        streets: r.array(filterSuggestionSchema).optional(),
        names: r.array(filterSuggestionSchema).optional(),
        codes: r.array(filterSuggestionSchema).optional(),
        isCompanyClosed: r.array(r.union([r.boolean(), r.literal('temporary_closed')])).nullish(),
        isCompanyActive: r.boolean().nullable(),
        isPaid: r.boolean().nullish(),
        needModerate: r.boolean().nullish(),
    }),
});

export type LastFilterStateType = r.infer<typeof mainFilterLastStateSchema>;
